import React, { useRef } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';
import Container from '../common/Container';
import useSlideInAnimation from '../../hooks/useSlideInAnimation';
import getIcon from '../../utils/experienceIcons';
import '../../styles/Experience.css';

const Experience = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const experienceRef = useRef(null);
    const t = translations[language].experience;

    // Usar el hook personalizado para animación de deslizamiento
    useSlideInAnimation('.experience-card');

    return (
        <section id="experience" className={`experience ${theme}`}>
            <Container>
                <h2 className="section-title">{t.title}</h2>
                
                <div className="timeline-container" ref={experienceRef}>
                    <div className="timeline-line"></div>
                    
                    {t.positions.map((exp, index) => (
                        <div 
                            key={index} 
                            className="experience-card"
                            style={{ animationDelay: `${index * 0.2}s` }}
                        >
                            <div className="experience-icon">
                                {getIcon(index)}
                            </div>
                            
                            <div className="experience-content">
                                <div className="experience-header">
                                    <h3>{exp.title}</h3>
                                    <span className="company">{exp.company}</span>
                                    <span className="period">{exp.period}</span>
                                </div>
                                
                                <p className="experience-description">
                                    {exp.description}
                                </p>
                                
                                <div className="achievements">
                                    <h4>{t.achievements}</h4>
                                    <ul>
                                        {exp.achievements.map((achievement, i) => (
                                            <li key={i}>{achievement}</li>
                                        ))}
                                    </ul>
                                </div>
                                
                                <div className="technologies-used">
                                    {exp.technologies.map((tech, i) => (
                                        <span key={i} className="tech-tag">
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};

export default Experience;